import { Decimal } from 'decimal.js'

export function deepCopy(target) {
    if (!target) {
	   console.warn('please input a true value');
	   return target
    }
    if (typeof target !== 'object') {
	   return target;
    }
    if (isEmptyObject(target)) {
      	let toString = Object.prototype.toString
      	if (toString.call(target) === '[object Object]') {
            return {};
      	} else {
            return [];
      	}
    }
    return JSON.parse(JSON.stringify(target));
}

export function isEmptyObject(object) {
    const keys = Object.keys(object);
    if (keys.length) {
	   return false;
    }
    return true;
}

const keepDecimal = (n) => {
    return function(num) {
        if (isNaN(num)) {
          console.warn(`${num} is not a number`)
          return false;
        }
        let roundNum = Math.round(num * 100) / 100;
        let result = roundNum.toString();
        let decimalPos = result.indexOf('.');
        if (decimalPos < 0) {
            decimalPos = result.length;
            result += '.';
        }
        while (result.length <= decimalPos + n) {
            result += '0';
        }
        return result;
    }
};

// export const changeTwoDecimal = keepDecimal(2);

/**
 * @param str 入参字符串
 * @returns
 */
export function isEmptyStr(str) {
  return typeof str === 'string'
    ? str.trim().length === 0
    : [undefined, null].includes(str);
}

/**
 * Decimal 十进制：加法
 * @param a
 * @param b
 * @returns
 */
export function addDecimals(a, b) {
  if (isEmptyStr(a) || isEmptyStr(b)) return NaN;
  const res = Decimal.add(a, b);
  return res.toNumber();
}

/**
 * Decimal 十进制：减法
 * 规定 a > b，不允许出现负数
 * @param a
 * @param b
 */
export function subDecimals(a, b) {
  if (isEmptyStr(a) || isEmptyStr(b)) return NaN;
  if (a < b) return NaN;
  const res = Decimal.sub(a, b);
  return res.toNumber();
}

/**
 * Decimal 十进制：乘法
 */
export function mulDecimals(a, b) {
  if (isEmptyStr(a) || isEmptyStr(b)) return NaN;
  const res = Decimal.mul(a, b);
  return res.toNumber();
}

/**
 * Decimal 十进制：除法
 * @param a
 * @param b
 * 分母 b 不能为0
 */
export function divDecimals(a, b) {
  if (isEmptyStr(a) || isEmptyStr(b)) return NaN;
  if (b === 0) return NaN;
  const res = Decimal.div(a, b);
  return res.toNumber();
}

/**
 * @param num
 * @returns
 * 此方法用于页面展示，返回字符串
 * 返回 整数补00
 * 返回一位小数 补0
 * 返回多位小数，转为字符串，原值返回，
 * calculateTotalPrice 至多6位小数，
 * 返回两位小数会截断处理，导致如果0.7162返回0.71，有抹零金额，会和原价对不上，所以前端不再处理接口返回值，仅对整数、一位小数补0
 *
 * 负数值、除法分母为0的计算 上面的运算方法返回NaN，页面里使用此方法再包一层，显示--
 */
export function changeTwoDecimal(num) {
  if (typeof num !== 'number' || Number.isNaN(num)) return '--';
  let stringNum = String(num);
  if (isEmptyStr(stringNum)) return stringNum;
  if (stringNum.includes('.')) {
    let [ integerPart, decimalPart ] = stringNum.split(".");
    if (decimalPart.length === 1) {
      decimalPart = `${decimalPart}0`;
    }
    stringNum = `${integerPart}.${decimalPart}`;
  } else {
    stringNum = `${stringNum}.00`;
  }
  return stringNum;
}

export function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

export function getDifferenceSet(arr1, arr2) {
    let l, shortArr, longArr;
    if (arr1.length > arr2.length) {
        shortArr = arr2;
        longArr = JSON.parse(JSON.stringify(arr1));
    } else {
        shortArr = arr1;
        longArr = JSON.parse(JSON.stringify(arr2));
    }
    l = shortArr.length;
    for (let i = l - 1; i >= 0; i--) {
        let { ipv6Address} = shortArr[i]
        let t = longArr.findIndex(item => item.ipv6Address === ipv6Address)
        if (t < 0) {
            longArr.push(arr2[i])
        } else {
            longArr.splice(t, 1)
        }
    }
    return longArr;
}

export function isIpv6(str) {
    return str.match(/:/g).length<=7
    &&/::/.test(str)
    ?/^([\da-f]{1,4}(:|::)){1,6}[\da-f]{1,4}$/i.test(str)
    :/^([\da-f]{1,4}:){7}[\da-f]{1,4}$/i.test(str);
}

export function compose(...args) {
    return (result) => {
        return args.reduceRight((result,fn) => {
            return fn(result)
        },result)
    }
}

export function pipe(...args) {
    return (result) => {
        return args.reduce((result) => {
            return fn(result)
        },result)
    }
}

export function dispatch(...args) {
    return (target) => {
        let result;
        for(let i = 0; i < args.length; i++) {
            result = args[i].call(args[i],target);
            if (result) {
                return result
            }
        }
        return result
    }
}

export function isTargetType(type, action) {
    return (target) => {
        if (type === target.type) {
            return action(target)
        }
    }
}


export function transformIpType(ipType) {
    let ipVersion = ipType && ipType.toLocaleLowerCase();
    switch (ipVersion) {
        case 'ipv6': {
            return 'IPv6';
            break;
        }
        case 'ipv4':
        default:  {
            return 'IPv4';
            break;
        }
    }
}


const months = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYear(year) {
    let r = year / 100;
    if (r === parseInt(r)) {
        r = year / 400;
        return r === parseInt(r);
    }
    r = year / 4;
    if (r === parseInt(r)) {
        return true
    }
    return false
}

function getDaysOfMonth(month, year) {
    if (month === 2 && isLeapYear(year)) {
        return 29
    }
    return months[month]
}

function getMonthsOfYear(year) {
    if (isLeapYear(year)) {
        return 366
    }
    return 365
}
export function calculatingTime(start,end) {
    let startArr = start.split('-').map(Number);
    let endArr = end.split('-').map(Number);
    let [year,month,day] = endArr.map((n, i) => n - startArr[i]);
    if (day < 0) {
        day += getDaysOfMonth(endArr[1],endArr[0]);
        month--;
    }
    if (month < 0) {
        month += getMonthsOfYear(endArr[0]);
        year--;
    }
    return [year,month,day]
}

/**
 * 数组去重 (兼容旧浏览器版本)
 * @param {Array} arr - 需要去重的数组
 * @returns {Array} 去重后的新数组
 */
export function uniqueArrayLegacy(arr) {
    if (!Array.isArray(arr)) {
        throw new TypeError('Expected an array');
    }

    const result = [];
    const seen = {};

    for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        const key = typeof item + JSON.stringify(item);

        if (!seen[key]) {
            seen[key] = true;
            result.push(item);
        }
    }

    return result;
}

/**
 * @description 往body元素上添加class（可用于对插入body中的元素的样式进行样式隔离）
 */
export function handleAddClassToBody (page) {
  document.body.classList.add(page);
}

/**
 * @description 移除body上的class
 */
export function handleRemoveClassFromBody (page) {
  // 从document.body的classList中移除指定的class
  // 首先通过Array.from将classList转换为数组
  // 然后使用filter筛选出与传入的page参数值相等的class名称
  // 最后使用展开运算符(...)将筛选结果作为参数传递给classList.remove方法
  document.body.classList.remove(...Array.from(document.body.classList).filter(c => c === page));
}



// WEBPACK FOOTER //
// ./src/common/tool.js